<template>
  <el-dialog
    ref="orderInfo"
    append-to-body
    :title="'【' + info.orderNo + '】' + ' 订单详情'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeDialog"
    width="80%"
  >
    <div class="order-contain">
      <div class="or-steps">
        <!--        <el-steps align-center process-status="finish" finish-status="success">
          <span v-for="(item,index) of info.orderTimePointList" :key="index">
            <el-step :title="item.operate" :description="item.timePoint" style="flex-basis: 100%;max-width: 100%;"></el-step>
          </span>
        </el-steps>-->
        <el-steps align-center :space="90">
          <el-step
            v-for="(item, index) of info.orderTimePointList"
            :key="index"
            class=""
            :title="item.operate"
          >
            <div slot="description" class="font-14 flex-1 text-center">{{ item.timePoint }}</div>
          </el-step>
        </el-steps>
      </div>

      <div class="tk_btn">
        <!--未支付隐藏退款按钮-->
        <div v-if="info.payStatus && info.payStatus === 2 && !info.tc">
          <el-button
            type="primary"
            size="small"
            @click.stop="handleRefund"
            v-has-permi="['order_ferry_refund']"
          >
            退款
          </el-button>
        </div>
        <div v-if="ferryStatus" class="margin-left-15">
          <el-button
            type="danger"
            size="small"
            @click="handleEndTrip"
            v-has-permi="['ferry_end_trip']"
          >
            结束行程
          </el-button>
        </div>
      </div>

      <div class="order-info">
        <span class="title">状态信息</span>
        <el-form :inline="true" label-width="130px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="订单编号:">
                {{ info.orderNo }}
              </el-form-item>
              <el-form-item label="城际客运订单编号:">
                <yd-link
                  :value="info.intercityOrderNo"
                  type="intercityInfo"
                  :need="true"
                  :query="{ id: info.intercityOrderId }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单状态:">
                <el-tag size="mini">{{ info.orderStatus | statusFilters }}</el-tag>
                <span class="pl" v-if="info.orderStatus === 2">
                  <el-button
                    type="primary"
                    size="mini"
                    @click.stop="handleSend"
                    v-has-permi="['order_ferry_send']"
                    :loading="btnLoading"
                  >
                    派单
                  </el-button>
                </span>

                <span class="pl" v-if="info.orderStatus !== 4 && info.orderStatus !== 2">
                  <el-button
                    type="primary"
                    size="mini"
                    @click.stop="handleSend"
                    v-has-permi="['order_ferry_reserve']"
                    :loading="btnLoading"
                  >
                    改派
                  </el-button>
                  <!-- <div class="tipsBox">
                    <img style="vertical-align: middle;width: 20px; height: 20px" src="./static/tips.png"></img>
                    <span>点击可派单给指定的摆渡司机！</span>
                  </div> -->
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="同城接单情况:">
                {{ info.acceptOrderStatus }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="order-info">
        <span class="title">乘客信息</span>
        <el-form :inline="true" label-width="130px">
          <el-row :gutter="28">
            <el-col :span="8">
              <el-form-item label="出发地:">
                <yd-link
                  :value="info.startAddress"
                  type="location"
                  :query="{
                    longitude: info.startLongitude,
                    latitude: info.startLatitude,
                    name: info.startAddress,
                    lineName: info.lineName
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="目的地:">
                <yd-link
                  :value="info.endAddress"
                  type="location"
                  :query="{
                    longitude: info.endLongitude,
                    latitude: info.endLatitude,
                    name: info.endAddress,
                    lineName: info.lineName
                  }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计出发时间:">
                {{ info.orderDepart }}
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="28">
            <!--            <el-col :span="8">-->
            <!--              <el-form-item label="预计到达时间:">-->
            <!--                {{ info.orderArrive }}-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="8">
              <el-form-item label="公里数:">{{ info.distance }} 公里</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计出行人数:">{{ info.passengerNumber }} 人</el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="乘车人姓名：">
                <!--                {{ info.passengerName}}-->
                <span v-show="info.passengerName !== null" v-text="info.passengerName"></span>
                <span v-show="info.passengerName === null">--</span>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="乘车人电话：">
                <yd-link
                  v-if="userList.includes(info.passengerPhone)"
                  permi="user_center_manage"
                  :value="info.passengerPhone"
                  :url="phoneUrl(info, info.passengerPhone)"
                  :need="true"
                  type="userInfo"
                />
                <span v-else>{{ info.passengerPhone }}</span>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="下单人姓名：">
                <span v-show="info.userName !== null" v-text="info.userName"></span>
                <span v-show="info.userName === null">--</span>
                <!--                {{ info.userName }}-->
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="下单人电话：">
                <yd-link
                  v-if="userList.includes(info.userPhone)"
                  permi="user_center_manage"
                  :value="info.userPhone"
                  :url="phoneUrl(info, info.userPhone)"
                  :need="true"
                  type="userInfo"
                />
                <span v-else>{{ info.userPhone }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="备注:">
                <!--                {{ info.orderRemark }}-->
                <span v-show="info.orderRemark !== null" v-text="info.orderRemark"></span>
                <span v-show="info.orderRemark === null">--</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单来源:">{{ info.orderOrigin }}</el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="云推官名称:">{{ info.agentName || '--' }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="云推官手机号:">{{ info.agentPhone || '--' }}</el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
      </div>

      <div class="order-info">
        <div class="title">交易信息</div>
        <div style="padding: 0 0 0 20px">
          <div class="margin-x-20 margin-top-10">
            <span class="margin-right-10">已付金额：{{ info.paySuccessAmount }}</span>
            <span class="margin-right-10">已退金额：{{ info.refundSuccessAmount }}</span>
            <span>订单剩余金额：{{ info.refundSurplusAmount }}</span>
          </div>
          <el-table :data="info.transactionInfo" border max-height="350px">
            <el-table-column prop="transactionType" label="交易类型" align="center" width="100" />
            <el-table-column prop="merchantOrderNo" label="商户单号(微信截图-短)" align="center" />
            <el-table-column prop="transactionOrderNo" label="交易单号(三方)" align="center" />
            <el-table-column prop="amount" label="金额" align="center" />
            <el-table-column prop="transactionTime" label="时间" align="center" />
          </el-table>
        </div>
      </div>

      <div class="order-info">
        <span class="title">服务信息</span>
        <div style="padding: 10px 0 0 20px">
          <el-table :data="info.driverOperationInfoList" border style="width: 100%">
            <el-table-column label="供应商信息" prop="merchantName" />
            <el-table-column label="司机姓名" prop="driverName">
              <template slot-scope="{ row }">
                <yd-link
                  permi="driver_data_normal"
                  :value="row.driverName"
                  :url="`/data-analysis/driver-data/normal/detail/${row.driverId}`"
                  type="userInfo"
                />
              </template>
            </el-table-column>
            <el-table-column label="司机手机号码" prop="driverPhone" />
            <el-table-column label="车牌号" prop="plateNumber">
              <template slot-scope="{ row }">
                <yd-link
                  permi="vehicle_view"
                  :value="row.plateNumber"
                  type="vehicleDetail"
                  :query="{ id: row.carId }"
                />
              </template>
            </el-table-column>
            <el-table-column label="司机类型" prop="driverType" />
            <el-table-column label="归属供应商" prop="merchantName" />
            <el-table-column label="接单时间" prop="time" />
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <el-tag size="mini">{{ scope.row.operationStatus | serviceStatusFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="operationRemark" />
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div v-if="scope.row.orderStatus !== 4">
                  <el-button type="text" size="small" @click="handleSend" :loading="btnLoading">
                    改派
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="order-info">
        <span class="title">退款信息</span>
        <div style="padding: 10px 0 0 20px">
          <el-table :data="info.orderRefundInfoList" border style="width: 100%">
            <el-table-column label="编号" prop="orderNo" width="130" align="left" />
            <el-table-column label="退款时间" prop="successTime" width="180" align="center" />
            <el-table-column label="退款金额" prop="refundAmount" width="100" align="center" />
            <el-table-column label="退款类型" prop="source" width="120" align="center">
              <template slot-scope="scope">
                <el-tag size="mini">{{ scope.row.source | sourceStatusFilter }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="违约金" prop="serviceCharge" width="80" align="center" />
            <el-table-column label="操作人" prop="createUserName" width="80" align="center" />
            <el-table-column label="备注" prop="remark" align="center" />
          </el-table>
        </div>
      </div>

      <div class="order-info">
        <span class="title">开票信息</span>
        <span style="display: flex; justify-content: flex-end">
          <el-button
            v-if="info.invoiceState === 1"
            size="mini"
            type="primary"
            @click="handleResetRed"
          >
            红冲
          </el-button>
          <el-button size="mini" type="primary" @click="handleReset">开票重置</el-button>
        </span>
        <el-form :inline="true" label-width="110px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="开票流水号:">
                <span v-show="info.serialNo !== null" v-text="info.serialNo"></span>
                <span v-show="info.serialNo === null">--</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票状态:">
                {{ info.invoiceStatusStr }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票金额:">{{ info.invoiceAmount }} 元</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票类型:">
                <!--                {{ info.invoiceType | invoTypeFilter }}-->
                <span
                  v-show="info.invoiceType !== null"
                  v-text="info.invoiceType | invoTypeFilter"
                ></span>
                <span v-show="info.invoiceType === null">--</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票信息:">
                <!--                {{ info.invoiceTitle }}-->
                <span v-show="info.invoiceTitle !== null" v-text="info.invoiceTitle"></span>
                <span v-show="info.invoiceTitle === null">--</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开票用户:">
                <!--                {{ info.invoiceUserPhone }}-->
                <span v-show="info.invoiceUserPhone !== null" v-text="info.invoiceUserPhone"></span>
                <span v-show="info.invoiceUserPhone === null">--</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="开票时间:">
                <!--                {{ info.invoiceCreateTime }}-->
                <span
                  v-show="info.invoiceCreateTime !== null"
                  v-text="info.invoiceCreateTime"
                ></span>
                <span v-show="info.invoiceCreateTime === null">--</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="申请时间:">
                <!--                {{ info.applyTime }}-->
                <span v-show="info.applyTime !== null" v-text="info.applyTime"></span>
                <span v-show="info.applyTime === null">--</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-button
        style="margin: 20px 0 10px 0"
        @click="showLogData"
        :loading="logLoading"
        size="small"
        type="primary"
      >
        操作日志
        <i class="el-icon-arrow-right" v-if="!showLog"></i>
        <i class="el-icon-arrow-down" v-else></i>
      </el-button>
      <transition name="el-fade-in-linear">
        <!-- <operation-log :list="logList" v-show="showLog"></operation-log> -->
        <operation-log v-show="showLog" :visible="showLog" :type="3" :flightPlanId="info.orderId" />
      </transition>
    </div>
    <!--退款-->
    <order-refund ref="refund" v-if="showRefundDialog" @refresh="handleRefresh" />
    <!--派单-->
    <order-send ref="send" v-if="showSendDialog" @refresh="handleRefresh" />
  </el-dialog>
</template>

<script>
  import OrderRefund from './order-refund'
  import OrderSend from './order-send'
  import { getOrder, getDriverByOrderNo } from '@/api/order'
  import OperationLog from '@/components/logInfo/list'
  import { ferryReset, resetRed, resetEndFerryTrip } from '@/api/invoice'
  import { phoneUrl } from '@/views/order/intercity/utils'

  export default {
    name: 'orderInfo',
    components: { OrderRefund, OrderSend, OperationLog },
    filters: {
      statusFilters(orderStatus) {
        let mark = ''
        switch (orderStatus) {
          case 1:
            mark = '待支付'
            break
          case 2:
            mark = '待接单'
            break
          case 3:
            mark = '待出发'
            break
          case 4:
            mark = '取消'
            break
          case 5:
            mark = '接人中'
            break
          case 6:
            mark = '待乘客上车'
            break
          case 7:
            mark = '行程中'
            break
          case 8:
            mark = '送达完成'
            break
          case 9:
            mark = '已退款'
            break
        }
        return mark
      },
      // 支付类型过滤
      payTypeFilters(payType) {
        let mark = ''
        switch (payType) {
          case 1:
            mark = '通联支付'
            break
        }
        return mark
      },
      // 服务状态过滤
      serviceStatusFilter(operationStatus) {
        let mark = ''
        switch (operationStatus) {
          case 1:
            mark = '接单'
            break
          case 2:
            mark = '出发接乘客'
            break
          case 3:
            mark = '待乘客上车'
            break
          case 4:
            mark = '取消'
            break
          case 5:
            mark = '行程中'
            break
          case 6:
            mark = '已完成'
            break
        }
        return mark
      },
      // 渠道状态
      sourceStatusFilter(source) {
        let mark = ''
        switch (source) {
          case 1:
            mark = '乘客退款'
            break
          case 2:
            mark = '后台退款'
            break
          case 3:
            mark = '系统自动退款'
            break
        }
        return mark
      },
      invoStatusFilter(t) {
        if (t === 0) return '待开票'
        if (t === 1) return '已开票'
        if (t === 2) return '已作废'
        if (t === 3) return '红冲'
      },
      invoTypeFilter(t) {
        if (t === 1) return '个人'
        if (t === 2) return '企业'
      }
    },

    data() {
      return {
        visible: false,
        showRefundDialog: false, // 退款
        showSendDialog: false, // 改派
        info: {
          // 订单信息
          orderNo: '',
          orderStatus: 1
        },
        logLoading: false,
        showLog: false,
        logList: [],
        btnLoading: false
      }
    },
    computed: {
      ferryStatus() {
        const status = [2, 3, 5, 6, 7]
        const res = status.includes(parseInt(this.info.orderStatus || 0, 10))
        return res
      },
      stepsStatus() {
        if (this.info.orderStatus === 1) {
          // 下单时间
          return 1
        }
        if (this.info.orderStatus === 2) {
          // 支付完成时间
          return 2
        }
        if (this.info.orderStatus === 3) {
          // 司机接单时间
          return 3
        }
        if (this.info.orderStatus === 5) {
          // 司机接单时间
          return 4
        }
        if (this.info.orderStatus === 6) {
          // 到达出发点时间
          return 5
        }
        if (this.info.orderStatus === 8) {
          //  乘客上车时间
          return 6
        }
        return undefined
      },
      userList() {
        const { userMap } = this.info || {}
        return Object.keys(userMap || {}) || []
      },
      phoneUrl() {
        return phoneUrl
      }
    },
    methods: {
      handleRefresh() {
        this.$emit('refresh')
      },
      showLogData() {
        this.showLog = !this.showLog
      },
      // 初始化数据
      init(row) {
        this.$loading({ text: '正在加载中～' })
        this.logList = []
        this.showLog = false
        getOrder(row.ferryOrderNo)
          .then((resp) => {
            if (resp.code === 0) {
              this.visible = true
              this.info = resp.data || {}
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      // 退款
      handleRefund() {
        this.showRefundDialog = true
        this.$nextTick(() => {
          this.$refs.refund.init(this.info)
        })
      },
      // 结束行程
      handleEndTrip() {
        this.$confirm(
          '为保障司乘双方权益，请确认司机已将乘客送达目的地后再结束该订单',
          '确认要结束行程订单吗？',
          {
            confirmButtonText: '确定',
            cancelButtonText: '稍后看看',
            type: 'warning'
          }
        )
          .then(() => {
            this.endOfTrip(this.info.orderId)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      endOfTrip(orderId) {
        resetEndFerryTrip(orderId).then((res) => {
          const { code } = res
          if (code === 0) {
            this.handleRefresh()
            this.$message.success('操作成功')
          }
        })
      },
      // 改派单
      async handleSend() {
        this.btnLoading = true

        // 判断供应商是否有权限去派单/改派
        const { code, data } = await getDriverByOrderNo({
          orderNo: this.info.orderNo,
          orderId: this.info.orderId
        })

        this.btnLoading = false

        if (code === 0) {
          this.showSendDialog = true
          this.$nextTick(() => {
            this.$refs.send.init(this.info, data)
          })
        }
      },
      handleResetRed() {
        this.$confirm('确定将发票红冲吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resetRed(this.info.serialNo).then((res) => {
            const { code } = res
            if (code !== 0) {
              return
            }
            this.$message.success('操作成功')
          })
        })
        // .then(() => {
        //   this.$message({
        //     type: 'success',
        //     message: '操作成功!'
        //   })
        // })
      },

      handleReset() {
        const data = {
          orderId: this.info.orderId,
          status: this.info.invoiceStatus
        }
        this.$confirm('确定将发票重置吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            return ferryReset(data)
          })
          .then((res) => {
            this.refreshData()
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          })
      },
      refreshData() {
        getOrder(this.info.orderNo).then((resp) => {
          if (resp.code === 0) {
            this.info = resp.data
          }
        })
      },
      closeDialog() {
        this.visible = false
        this.info = {}
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: inline-block;
    margin: 0 0 0 10px;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  .order-contain {
    width: 100%;
    flex: 1;
    padding: 0;
    margin: 0;

    /*.or-steps {
      display: flex;
      justify-content: space-between;
      background-color: red;
    }*/
    .order-step-item {
      margin-left: 50px;
    }
    .tk_btn {
      position: absolute;
      top: 22px;
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      left: -90px;
    }
    .title {
      font-size: 16px;
      font-weight: 800;
    }
    .order-info {
      margin-top: 18px;
    }
  }
  .pl {
    padding-left: 10px;
  }
  ::v-deep .el-step__title {
    font-size: 14px;
    line-height: 38px;
  }
  ::v-deep .el-step__description {
    padding: 0 !important;
    margin-top: -4px;
    font-size: 8px;
    line-height: 20px;
    font-weight: 400;
    width: 76px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 4px !important;
  }
</style>
